import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { useWatch } from 'react-hook-form';

import { IconTypes } from '@eika/icon';
import { ErrorLabel, Label } from '@eika/label';

import { useWatchError } from '@/domain/app';
import { Translations, useTranslations } from '@/domain/translations';
import { formatAmount } from '@/utils/text-format-utils';

import { PayService } from '../../Pay';

import './AmountWrapper.scss';

interface Props {
    children: ReactNode;
}

type AmountField = {
    amount: string;
};

const getLabelText = (t: Translations, amount: string) => {
    const amountNumber = Number(amount);

    if (amountNumber === 0 || Number.isNaN(amountNumber)) {
        return t.pay.field.amount.costsInfo;
    }

    const costs = PayService.cost(amountNumber);

    return t.pay.field.amount.costsSummary.replace('{}', formatAmount(costs));
};

export const AmountWrapper: React.FC<Props> = ({ children }) => {
    const t = useTranslations();

    const amountError = useWatchError<AmountField>('amount', 'pay.validation.amount.required');
    const amount = useWatch<AmountField>({ name: 'amount' });

    const label = getLabelText(t, amount);

    const error = amountError && (amountError as string);

    return (
        <div className="amount-wrapper__container">
            <div className={classNames('amount-wrapper')}>{children}</div>
            {error && (
                <div className="amount-wrapper__label-container">
                    <ErrorLabel className="amount-wrapper__label" icon={IconTypes.UTROPSTEGN_24} text={error} />
                </div>
            )}
            {label && (
                <div className="amount-wrapper__label-container">
                    <Label className="amount-wrapper__label" text={label} />
                </div>
            )}
        </div>
    );
};
